import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { find } from 'lodash';

import { configSelector } from 'shared/app/shell';
import CaloriesDisclaimerTooltip from '../../calories-disclaimer-tooltip';
import { usePdpContext } from '../../pdp-provider';

import messages from '../messages';
import styles from './styles.cssm';

const FAT_ID = 'totalFat';
const CARBS_ID = 'totalCarbs';
const SUGARS_ID = 'sugars';

const getFactsById = (object, id) => {
  return find(object, (i) => i.id === id);
};
const hasValue = (item) => Boolean(item) || item === 0;

const NutritionSummary = () => {
  const pdpMatchTitleAndCaloriesFont =
    useSelector(configSelector)?.pdpMatchTitleAndCaloriesFont;
  const summaryClass = pdpMatchTitleAndCaloriesFont
    ? styles.nutritionSummaryLarge
    : styles.nutritionSummary;

  const nutrition = usePdpContext().sizeInfo?.selectedSize?.nutrition;
  const fatInfo = getFactsById(nutrition?.additionalFacts, FAT_ID);
  const carbsInfo = getFactsById(nutrition?.additionalFacts, CARBS_ID);
  const sugarsInfo = getFactsById(carbsInfo?.subfacts, SUGARS_ID);

  // displayValue of calories is a number; the others are a string which includes a unit (eg. ' 9 g')
  const caloriesValue = nutrition?.calories?.displayValue;
  const fatValue = fatInfo?.displayValue?.replace(/\s/g, '');
  const sugarValue = sugarsInfo?.displayValue?.replace(/\s/g, '');

  // check to keep 'undefined' from accidentally rendering in the UI
  if (!hasValue(caloriesValue) || !fatValue || !sugarValue) {
    return null;
  }

  return (
    <div
      className="flex items-center color-textWhite pt3"
      data-e2e="nutrition-summary"
    >
      <span className={summaryClass}>
        <FormattedMessage
          {...messages.nutritionSummary}
          values={{
            caloriesValue,
            fatValue,
            sugarValue,
          }}
        />
      </span>
      <CaloriesDisclaimerTooltip innerClassName={styles.caloriesIconWrapper} />
    </div>
  );
};

export default NutritionSummary;
